<deloitteai-page [logoUrl]="logoUrl" [desktopHamburgerLogoUrl]="desktopHamburgerLogoUrl"></deloitteai-page>
